import script from "./NationalityEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./NationalityEdit.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__